import { Component, Input, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

let inc = 0;

@Component({
  selector: 'mkt-tab-panel',
  templateUrl: './mkt-tab-panel.component.html',
  styleUrls: ['./mkt-tab-panel.component.scss'],
  standalone: false,
  host: {
    'role': 'tabpanel',
    'class': 'tabpanel'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MktTabPanelComponent {
  private _groupId: string;
  public set groupId(val) { this._groupId = val; this.setIds(); }
  public get groupId() { return this._groupId; }

  private _index: number;
  public set index(val) { this._index = val; this.setIds(); }
  public get index() { return this._index; }

  @Input('navTitle') public navTitle: string;
  @Input('iconClass') public iconClass: string;
  @Input('iconPath') public iconPath: string;
  @HostBinding('attr.id') hostId: string = '';
  @HostBinding('attr.aria-labelledby') labelledby: string = '';
  @HostBinding('class.tabpanel-active') isSelected: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  setIds() {
    setTimeout(() => {
      if (!(this.groupId+'') || !(this.index+'')) return;

      this.hostId = this.groupId + '-tabpanel-' + this.index;
      this.labelledby = this.groupId + '-tab-' + this.index;

      this.cdr.detectChanges();
    }, 0);
  }
}
